import { EyeIcon, EyeClosedIcon } from "@phosphor-icons/react";
import { useState } from "react";
import ikas from "../../providers/ikas";
import { useNavigate } from "react-router-dom";

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validatePassword(password) {
  return password.length >= 6;
}

export default function Login({ data, dataSetter }) {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [revealPassword, setRevealPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  const onEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };
  const onPasswordChange = (e) => {
    setPassword(e.target.value);
    setError("");
  };
  const onRememberMeChange = () => setRememberMe((prev) => !prev);
  const onTogglePassword = () => setRevealPassword((prev) => !prev);

  const onLoginClick = () => {
    if (!validateEmail(email)) {
      setError("Geçerli bir e-posta adresi giriniz.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Şifre en az 6 karakter olmalıdır.");
      return;
    }
    setError("");
    setLoading(true);
    ikas
      .customerLogin(email, password, rememberMe)
      .then(async (response) => {
        setLoading(false);
        dataSetter(response);
        setToast("Giriş işlemi başarılı");
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          setTimeout(() => {
            setToast("");
            navigate("/account");
          }, 400);
        }, 1200);
      })
      .catch(() => {
        setLoading(false);
        setError("Giriş başarısız. Bilgilerinizi kontrol edin.");
      });
  };

  const onRegisterClick = () => navigate("/register");
  const onPrivacyPolicyClick = () => navigate("/privacy-policy");
  const onForgotPasswordClick = () => navigate("/forgot-password");

  return (
    <div className="relative">
      {toast && (
        <div
          className={`fixed left-1/2 transform -translate-x-1/2 z-[100] w-[95vw] max-w-xl bg-[#6f59ef] text-white px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400
            ${showToast ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"}`}
          style={{ minWidth: 320, top: data?.system?.safeArea?.top ?? 20 }}
        >
          {toast}
        </div>
      )}

      {loading && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 transition-opacity duration-200"></div>
      )}

      <div className="m-1 mt-[10vh] flex flex-col items-center min-h-screen">
        <div
          className="w-full max-w-sm min-w-[200px] bg-white p-4 rounded-lg relative sm:max-w-md md:max-w-lg"
          style={loading ? { pointerEvents: "none" } : {}}
        >
          {/* Email Input */}
          <div className="relative flex items-center">
            <svg
              fill="#000000"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
  
              viewBox="0 0 100 100"
              enableBackground="new 0 0 100 100"
              xmlSpace="preserve"
              className="absolute w-5 h-5 top-2 left-2.5 text-slate-600"
            >
              <g>
                <path d="M13.266,81h73.469C89.087,81,91,78.967,91,76.614V26.165c0-0.009,0.003,0.043,0.003,0.034c0-2.348-1.914-4.199-4.267-4.199 h-0.002H13.612h-0.347C10.913,22,9,23.795,9,26.147v50.467C9,78.967,10.913,81,13.266,81z M38.525,49.122L13,74.442V29.89 L38.525,49.122z M87,30.186v42.289L62.914,48.581L87,30.186z M59.723,51.02c0.044,0.053,0.082,0.169,0.132,0.22L85.764,77H16.221 l25.533-25.387l7.481,5.607c0.356,0.268,0.779,0.388,1.203,0.388c0.428,0,0.855-0.144,1.214-0.418L59.723,51.02z M86.047,26 L50.431,53.202L14.326,26H86.047z" />
              </g>
            </svg>
            <input
              value={email}
              onChange={onEmailChange}
              type="email"
              className="w-full pl-10 py-2 bg-transparent placeholder:text-gray-500 text-black text-sm border border-gray-200 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm"
              placeholder="E-posta"
              autoComplete="email"
            />
          </div>

          {/* Password Input */}
          <div className="relative mt-4 flex items-center">
             <svg
           
              viewBox="0 0 1024 1024"
              className="absolute w-5 h-5 top-2 left-2.5 text-slate-600"
              xmlns="http://www.w3.org/2000/svg"

            >
              <path
                fill="#555555"
                d="M224 448a32 32 0 00-32 32v384a32 32 0 0032 32h576a32 32 0 0032-32V480a32 32 0 00-32-32H224zm0-64h576a96 96 0 0196 96v384a96 96 0 01-96 96H224a96 96 0 01-96-96V480a96 96 0 0196-96z"
              />
              <path
                fill="#555555"
                d="M512 544a32 32 0 0132 32v192a32 32 0 11-64 0V576a32 32 0 0132-32zM704 384v-64a192 192 0 10-384 0v64h384zM512 64a256 256 0 01256 256v128H256V320A256 256 0 01512 64z"
              />
            </svg>
            <input
              value={password}
              onChange={onPasswordChange}
              type={revealPassword ? "text" : "password"}
              className="w-full pl-10 pr-10 py-2 bg-transparent placeholder:text-gray-500 text-black text-sm border border-gray-200 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm"
              placeholder="Şifre"
              autoComplete="current-password"
            />
            <div onClick={onTogglePassword}>
              {revealPassword ? (
                <EyeIcon className="absolute w-5 h-5 top-2.5 right-2.5 text-slate-600 cursor-pointer" />
              ) : (
                <EyeClosedIcon className="absolute w-5 h-5 top-2.5 right-2.5 text-slate-600 cursor-pointer" />
              )}
            </div>
          </div>

          {/* Error */}
          {error && <div className="mt-1 text-red-500 text-sm">{error}</div>}

          {/* Remember Me */}
          <div className="inline-flex justify-center items-center self-center mt-6 w-full">
            <label className="flex items-center cursor-pointer relative" htmlFor="check-2">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={onRememberMeChange}
                className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                id="check-2"
              />
              <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M16.707 5.293a1 1 0 010 1.414l-8 8-4-4 1.414-1.414L8 12.586l7.293-7.293z" />
                </svg>
              </span>
            </label>
            <label className="cursor-pointer ml-2 text-black text-sm font-semibold" htmlFor="check-2">
              Beni Hatırla
            </label>
          </div>

          {/* Login Button */}
          <button
            className="w-full font-bold text-base text-white p-2.5 mt-4 rounded-lg text-center transition-colors duration-200 flex items-center justify-center"
            style={{ backgroundColor: "#6f59ef", minHeight: "42px" }}
            onClick={onLoginClick}
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <span className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
              </span>
            ) : (
              "Giriş Yap"
            )}
          </button>

          {/* Forgot Password */}
          <button
            className="w-full text-sm font-medium p-3 mt-4 rounded-xl text-center transition-colors duration-200"
            style={{ color: "#6f59ef", backgroundColor: "transparent" }}
            onClick={onForgotPasswordClick}
          >
            Şifrenizi mi unuttunuz?
          </button>

          {/* Privacy Policy */}
          <p className="w-full text-sm text-black font-medium text-center mt-2 px-4">
            Devam ederek,{" "}
            <span
              onClick={onPrivacyPolicyClick}
              className="cursor-pointer"
              style={{ color: "#6f59ef" }}
            >
              Gizlilik Politikasını
            </span>{" "}
            kabul etmiş olursunuz.
          </p>

          {/* Register */}
          <p className="w-full text-md text-black font-bold p-3 mt-16 rounded-xl text-center">
            Hesabınız yok mu?{" "}
            <span
              onClick={onRegisterClick}
              className="cursor-pointer"
              style={{ color: "#6f59ef" }}
            >
              Üye Ol
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}